"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGrantTypes = getGrantTypes;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _exchangeApiClient = require("@mulesoft/exchange-api-client");
var EMPTY_IDP = {
  grantTypes: [],
  isConfigurable: true,
  identityManagementType: null
};
function getGrantTypes(_x) {
  return _getGrantTypes.apply(this, arguments);
}
function _getGrantTypes() {
  _getGrantTypes = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee(_ref) {
    var context, config, masterOrganizationId, providerId, identityProviderService, grantTypes;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          context = _ref.context, config = _ref.config, masterOrganizationId = _ref.masterOrganizationId, providerId = _ref.providerId;
          if (providerId) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return", EMPTY_IDP);
        case 3:
          identityProviderService = new _exchangeApiClient.IdentityProviderService(config);
          _context.prev = 4;
          _context.next = 7;
          return identityProviderService.getGrantTypes({
            context: context,
            masterOrganizationId: masterOrganizationId,
            providerId: providerId
          });
        case 7:
          grantTypes = _context.sent;
          return _context.abrupt("return", grantTypes);
        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](4);
          if (!(_context.t0.status === 404)) {
            _context.next = 15;
            break;
          }
          return _context.abrupt("return", EMPTY_IDP);
        case 15:
          throw _context.t0;
        case 16:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[4, 11]]);
  }));
  return _getGrantTypes.apply(this, arguments);
}
//# sourceMappingURL=identity.js.map